import { Component, OnInit } from '@angular/core';
import { Eht } from '../../../classes/eht';
import { NgForm } from '@angular/forms';
import { EhtService } from '../../../services/eht.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../../shared/services/user.service';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-eht-page',
  templateUrl: './eht-page.component.html',
  styleUrls: ['./eht-page.component.scss']
})
export class EhtPageComponent implements OnInit {
  eht: Eht = <Eht>{};
  ehts: Eht[] = [];
  edit: boolean[] = [];
  editing: boolean[] = [];
  sub: any;
  orgId: number;
  isAdmin: boolean;
  adding: boolean;
  company: any;
  steps: any;
  incomplete: boolean;
  state: any;
  errMsg: string;
  focus: any[] = [];
  rnFocus: boolean = false;
  teFocus: boolean = false;
  exFocus: boolean = false;

  constructor(
    private EhtService: EhtService,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService,
    private CompanyService: CompanyService,
    private router: Router
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      let errId: number = +params['errId'];
      if (errId == 1) {
        this.errMsg = 'You cannot go to next step until Business Info, Remittance Info, Banking info and Payroll Schedule are filled.'
      }
      this.getEhts();
      this.getComplete();
    });
    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
    this.titleService.setTitle('EHT');
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getComplete() {
    this.CompanyService.getCompany(this.orgId)
      .subscribe(company => {
        this.company = JSON.parse(company.organization);
        this.steps = JSON.parse(company.steps);
        this.incomplete = this.steps.slice(0, 3).some(s => {
          console.log(s)
          return !s[2];
        })
        this.state = JSON.parse(company.state);

      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }


  getEhts() {
    this.EhtService.getEht(this.orgId)
      .subscribe(ehts => {
        console.log(ehts)
        this.ehts = JSON.parse(ehts.ehts || '[]');
        this.edit = this.ehts.map(e => {
          return false;
        });
        this.editing = JSON.parse(JSON.stringify(this.edit));
        this.focus = this.ehts.map(e => {
          return {
            rnFocus: false,
            teFocus: false,
            exFocus: false
          };
        });
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  addEht(ehtForm: NgForm) {
    this.adding = true;
    if (ehtForm.invalid) {
      return;
    }
    this.EhtService.addEht(this.orgId, this.eht)
      .subscribe(ehts => {
        this.adding = false;
        ehtForm.reset();
        this.eht = <Eht>{};
        this.getEhts();
        this.getComplete();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  completeEht(id: number, ehtForm: NgForm, eht: Eht, index: number) {
    this.editing[index] = true;
    if (ehtForm.invalid) {
      return;
    }
    this.EhtService.editEht(this.orgId, id, eht)
      .subscribe(ehts => {
        this.editing[index] = false;
        this.getEhts();
        this.getComplete();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  editEht(index: number) {
    this.edit[index] = true;
  }

  deleteEht(id: number) {
    this.EhtService.deleteEht(this.orgId, id)
      .subscribe(ehts => {
        this.getEhts();
        this.getComplete();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/eht-page/eht-page.component.ts